module.exports = __webpack_public_path__ + "img/Group 54.ef662ea8.jpg";